// 交易看板表格組件
export default {
  // 表格頭部
  totalRecords: "共計",
  records: "條數據",
  loading: "拼命加載中",

  // 表格列標題
  blockchain: "公鏈",
  address: "地址",
  transferInCount: "轉入次數",
  transferInAmount: "轉入數量",
  transferOutCount: "轉出次數",
  transferOutAmount: "轉出數量",
  remark: "備註",
  action: "操作",

  // 備註相關
  addRemark: "點擊添加備註",
  remarkSuccess: "備註成功",

  // 操作按鈕
  delete: "刪除",
  download: "下載數據明細",

  // 空狀態
  noData: "暫無數據",

  // 消息提示
  addressNotFound: "沒有查出該地址",
  copySuccess: "複製成功",
  deleteConfirm: "是否刪除此條地址?",
  deleteSuccess: "刪除成功",
  deleteCancelled: "已取消刪除",
  lastAddressWarning: "此地址為最後一條，不可刪除",

  // 對話框
  tip: "刪除確認",
  confirm: "確定",
  cancel: "取消",
  warning: "警告",
};
